export default "__VITE_ASSET__HAUrt54q__"